import React from 'react';
import MaskedInput from 'react-text-mask';

import type { InputBaseComponentProps } from '@material-ui/core';

type LapPlatoonMaskNumberMaskProps = Omit<InputBaseComponentProps, 'onKeyDown'>;

const LapPlatoonMask = (props: LapPlatoonMaskNumberMaskProps): React.ReactElement => {
    const { inputRef, value, min, max, ...otherProps } = props;

    const mask = new RegExp(`[${min}-${max}]`);

    return (
        <MaskedInput
            ref={ref => inputRef(ref ? ref.inputElement : null)}
            value={value}
            mask={[mask]}
            {...otherProps}
        />
    );
};

export { LapPlatoonMask };
